import { Link } from "react-router-dom";
import type { Article } from "@/lib/api";
import { formatArticlePrice, formatRelativeDate } from "@/lib/format";
import { Badge } from "@/components/ui/Badge";
import { Button } from "@/components/ui/Button";
import { Pencil, Eye, EyeOff } from "lucide-react";

interface ArticleRowProps {
  article: Article;
  onTogglePublish: (id: string, published: boolean) => void;
  publishing?: boolean;
}

export function ArticleRow({
  article,
  onTogglePublish,
  publishing,
}: ArticleRowProps) {
  return (
    <div className="flex items-center gap-4 py-4 border-b border-beige/10 last:border-0">
      <div className="flex-1 min-w-0">
        <h4 className="font-body font-bold text-sm truncate">
          {article.title}
        </h4>
        <div className="flex items-center gap-2 mt-1">
          <Badge variant={article.published ? "success" : "default"}>
            {article.published ? "Published" : "Draft"}
          </Badge>
          <span className="text-xs text-beige font-body">
            {formatArticlePrice(article.priceUsdc, article.priceEurc)}
          </span>
          <span className="text-xs text-beige font-body">
            {formatRelativeDate(article.updatedAt)}
          </span>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <Link to={`/writer/articles/${article.id}/edit`}>
          <Button variant="ghost" size="sm">
            <Pencil size={14} />
          </Button>
        </Link>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onTogglePublish(article.id, !article.published)}
          disabled={publishing}
        >
          {article.published ? <EyeOff size={14} /> : <Eye size={14} />}
        </Button>
      </div>
    </div>
  );
}
